import React from 'react';

import { twMerge } from 'tailwind-merge';
import { MoreContentOptions } from './MoreContentOptions/MoreContentOptions';
import { UserInformation } from './UserInformation/UserInformation';

interface RegistryWallProps {
  className?: string;
  userAvatarUrl: string;
  userNickname: string;
}

export const RegistryWall = ({ className, userAvatarUrl, userNickname }: RegistryWallProps) => {
  return (
    <div className={twMerge('flex flex-1 flex-col items-center justify-center p-4', className)}>
      <UserInformation
        className="max-w-[450px]"
        userAvatarUrl={userAvatarUrl}
        userNickname={userNickname}
      />
      <MoreContentOptions className="max-w-[450px]" />
    </div>
  );
};
